module.exports = new __parcel__URL__("epa-annual--cover.372741ab.jpg").toString();